/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ChapterPricing} from "./chapterPricing.zod";
import {FinancialAvailability} from "./financialAvailability.zod";

export const EvaluatedOfferChapter = zod
  .unknown()
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(
    zod.object({
      chapterId: zod.uuid(),
      costAvailability: zod.enum(["AVAILABLE", "RESTRICTED", "UNAVAILABLE"]),
      coefficientAvailability: zod.enum(["AVAILABLE", "RESTRICTED", "NOT_PRICED"]),
      commissionFractionAvailability: zod.enum(["AVAILABLE", "RESTRICTED", "UNAVAILABLE"]),
      costWithBenefitAvailability: FinancialAvailability,
      commissionAvailability: FinancialAvailability,
      totalAvailability: FinancialAvailability,
      salePriceAvailability: zod.enum(["AVAILABLE", "UNAVAILABLE", "NOT_PRICED"]),
      benefitAvailability: FinancialAvailability,
      pricing: ChapterPricing.optional(),
    }),
  )
  .describe(
    "Known supplier cost is independent of absent coefficients. NOT_PRICED is not a content defect. Available final selling is visible even when contributing costs are restricted. Each internal fact has independent availability; coefficient requires protected-price observe even for an unprotected Chapter.",
  );

export type EvaluatedOfferChapter = zod.input<typeof EvaluatedOfferChapter>;
export type EvaluatedOfferChapterOutput = zod.output<typeof EvaluatedOfferChapter>;
